
window.wheelProducts = window.wheelProducts || {}
const wheelList = document.querySelector(".wheel-selection__list")

class WheelQuantityInput extends QuantityInput {
    constructor() {
        super();
        this.data = JSON.parse(this.querySelector("[data-wheel-data]").textContent);
        wheelProducts[this.data.id] = {
            price: this.data.price,
            qty: this.input.value
        }
    }

    onChange() {
        if (Number(this.input.value) > Number(this.input.max)) {
            this.input.value = this.input.max;
        }

        if (Number(this.input.value) < 0) {
            this.input.value = "0";
        }

        wheelProducts[this.data.id] = {
            ...wheelProducts[this.data.id],
            qty: Number(this.input.value)
        }
    }

    onButtonClick(event) {
        event.preventDefault();
        const previousValue = this.input.value;

        event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
        if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
    }


}



customElements.define('wheel-quantity-input', WheelQuantityInput);

function updatePrice() {
    const productForm = document.getElementById(wheelList.dataset.form);
    const currencySymbol = wheelList.dataset.currencySymbol;
    const button = productForm.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const mainQuantity = Number(document.querySelector("input[name='quantity']").value)
    const priceElement = document.querySelector(".price-item")
    let price = Number(priceElement.dataset.price * mainQuantity) / 100;
    for (const id in wheelProducts) {
        const wheel = wheelProducts[id];

        price += (wheel.price * wheel.qty);
    }

    price = price.toFixed(2)
    if (button.hasAttribute('disabled')) {
        addButtonText.textContent = window.variantStrings.soldOut;
    } else if (button.hasAttribute('preorder')) {
        addButtonText.textContent = `${window.variantStrings.preorder} - ${currencySymbol}${price}`;
    }
    else {
        addButtonText.textContent = `${window.variantStrings.addToCart} - ${currencySymbol}${price}`;
    }
}

if (wheelList) {
    
    window.addEventListener("pageshow", () => {
        const allQtyInputs = document.querySelectorAll("wheel-quantity-input input");
        allQtyInputs.forEach(input => {
            const defaultQuantity = Number(input.dataset.defaultQuantity);
            input.value = defaultQuantity != NaN ? defaultQuantity : "0"
        });
        updatePrice()
    });
    document.addEventListener("change", updatePrice)
    document.addEventListener("VariantChanged", updatePrice)


//     document.addEventListener("AddToCart", function (event) {

//         if (!event?.detail?.line_item_key) return;

//         // Private line item properties
//         const properties = {
//             "_hiddenFromCartCount": true,
//             "_associatedWithLineItemKey": event.detail.line_item_key,
//         };

//         // Public line item properties
//         properties[window.Resources.pdp.steel_selection.added_with] = wheelList.dataset.varianTitle;
//         let items = []

//         for (const id in window.wheelProducts) {
//             const wheel = wheelProducts[id];
//             const item = {
//                 id: Number(id),
//                 quantity: wheel.qty
//             }

//             if (JSON.parse(wheelList.dataset.associatedWithParent)) {
//                 item.properties = properties
//             }

//             items.push(item)
//         }

//         items = items.filter(item => item.quantity > 0)

//         if (items.length > 0) {
//             fetch(window.Shopify.routes.root + 'cart/add.js', {
//                 method: 'POST',
//                 headers: { 'Content-Type': 'application/json', 'Accept': `application/json` },
//                 body: JSON.stringify({ items })
//             }).catch(err => console.log(err));
//         }
//     })
}